import { Settings } from "./settings";

export const debug_log = function (msg, level = 0) {
  Settings.debugging() &&
    Settings.debug_level() >= level &&
    console.debug(`DEBUG::l${level}::`, msg);
};
